<template>
    <img :src="$page.props.tenant.logo" draggable="false"/>
</template>
